module.exports = __webpack_public_path__ + "img/cloud2.353921eb.webp";